module.exports = __webpack_public_path__ + "static/media/empathy_waves.a3d1c413.webp";